export default __webpack_public_path__ + "static/media/checked.9e048b91.svg";